import { createTRPCProxyClient, httpLink } from "@trpc/client";
import type { AdminRouter } from "evangelist-api/src/adminRouter";
import { useAuth } from "~/layers/auth/composables/useAuth";
import { VueQueryPlugin } from "@tanstack/vue-query";
export type {
  AdminRouterInput as RouterInput,
  AdminRouterOutput as RouterOutput,
} from "evangelist-api/src/adminRouter";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const { logout, getSessionToken } = useAuth();
  useNuxtApp().vueApp.use(VueQueryPlugin);

  const trpc = createTRPCProxyClient<AdminRouter>({
    links: [
      // not using httpBatchLink:
      // Clients connect using HTTP/2, and then Azure sends it to Container App as HTTP/1.1
      // So we don't really get any speedup from batching on the clients, and not batching makes debugging simpler.
      httpLink({
        url: `${config.public.TRPC_URL}`,
        async headers() {
          const token = getSessionToken();
          if (token) {
            return { authorization: `Bearer ${token}` };
          }
          return {};
        },
        // Log out if we get a 401
        fetch: async (url, options): Promise<Response> => {
          const res = await fetch(url, options);

          if (
            res.status === 401 &&
            !String(url).endsWith("admin.getCurrentUser")
          ) {
            logout();
            return new Response(
              JSON.stringify({
                error: {
                  message: "UNAUTHORIZED",
                  code: -32001,
                  data: {
                    code: "UNAUTHORIZED",
                    httpStatus: 401,
                    path: "admin.getCurrentUser",
                  },
                },
              }),
              { status: 401 },
            );
          } else {
            return res;
          }
        },
      }),
    ],
  });

  return {
    provide: {
      trpc,
    },
  };
});
